(function() {
    'use strict';

    angular
        .module('as.search')
        .controller('SearchMainPage', SearchMainPage)
        .controller('searchDeleteModalCtrl', searchDeleteModalCtrl)
        .controller('searchEditModalCtrl', searchEditModalCtrl);



    SearchMainPage.$inject = ['$scope', '$location', '$http', '$filter', '$window', 'asMessages', '$timeout', 'ModalService', 'suggestions', '$stateParams', 'sidetopHttp', '$state', '$rootScope', 'adminRights', 'invitation','analytics','userdata'];

    function SearchMainPage($scope, $location, $http, $filter, $window, asMessages, $timeout, ModalService, suggestions, $stateParams, sidetopHttp, $state, $rootScope, adminRights, invitation,analytics,userdata) {
        //variable

        var allowed_subinst = userdata.fetchAllowedSubinst();

        $scope.includeNonSubInstiUsers = true;

        
        // availabeFields:["name","membership_id","membership_number","company","city","hometown","institute","department","degree","specialization","professional_networks","email","company","designation"]
        $scope.editable_fields  = {
            role:{name: $filter('asLingo')('1'),
                    edit:true,
                    clear:false,
                    show_edit_field:true},
            subinst:{name: $filter('asLingo')('45'),
                    edit:true,
                    clear:true,
                    show_edit_field:$rootScope.app_data.data.insti_type==3?true:false},
            institute:{name: $filter('asLingo')('284'),
                    edit:true,
                    clear:true,
                    show_edit_field:true},
            yoj:{name: $filter('asLingo')('2'),
                    edit:true,
                    clear:true,
                    show_edit_field:true},
            yop:{name: $filter('asLingo')('3'),
                    edit:true,
                    clear:true,
                    show_edit_field:true},
            department:{name: $filter('asLingo')('5'),
                    edit:true,
                    clear:true,
                    show_edit_field:true},
            degree:{name: $filter('asLingo')('4'),
                    edit:true,
                    clear:true,
                    show_edit_field:true},
            specialization:{name: $filter('asLingo')('283'),
                    edit:true,
                    clear:true,
                    show_edit_field:true},
            enrollment_number:{name: $filter('asLingo')('28'),
                    edit:false,
                    clear:true,
                    show_edit_field:true},
            identity_number:{name: $filter('asLingo')('312'),
                    edit:false,
                    clear:true,
                    show_edit_field:true},
            membership_number:{name: $filter('asLingo')('299'),
                    edit:false,
                    clear:true,
                    show_edit_field:$rootScope.featureEnabled('membership',false)},
            // admin_assigned_membership:{name: "Admin assigned memberships",
            //         edit:false,
            //         clear:true,
            //         show_edit_field:$rootScope.featureEnabled('membership',false)},
            phone_number:{
                    name:$filter('asLingo')('218'),
                    edit:false,
                    clear:true,
                    show_edit_field:adminRights.isAllowed(7)
                },
            city:{name: $filter('asLingo')('43'),
                    edit:true,
                    clear:true,
                    show_edit_field:true},
            hometown:{name:$filter('asLingo')('227'),
                    edit:true,
                    clear:true,
                    show_edit_field:true},
            work:{
                    name:$filter("asPortalLang")("Work_Info","Work Information"),
                    edit:false,
                    clear:true,
                    show_edit_field:true
                },
            education:{
                    name: $filter('asLingo')('180'),
                    edit:false,
                    clear:true,
                    show_edit_field:true
                },
            gender:{name:$filter('asLingo')('215'),
                    edit:true,
                    clear:true,
                    show_edit_field:true},
            dob:{
                    name:$filter("asLingo")('216'),
                    edit:false,
                    clear:true,
                    show_edit_field:true
                },
            marital_status:{
                    name:$filter("asPortalLang")("Marital_Status","Marital Status"),
                    edit:true,
                    clear:true,
                    show_edit_field:true
                },
            auth_status:{
                    name:$filter("asPortalLang")("Profile_Status","Profile Status"),
                    edit:true,
                    clear:false,
                    show_edit_field:true
                }
            };
        var uuis = [];
        var uuis_to_process = [];
        
        //function bindings
        $scope.toggleAllCheckbox = function(v) {
            if(angular.isDefined($scope.num_deleted))
                $scope.num_deleted = 0;
            if(angular.isDefined($scope.num_edited))
                $scope.num_edited = 0;
            if(angular.isDefined($scope.adminErrorMessage))
                $scope.adminErrorMessage = "";
            $scope.allSelected = v;
            $scope.num_selected = 0;
            $scope.searchLangData.profileSelCount = 0;
            $scope.resultCountForSubInstInModal = 0;
            $scope.resultCountForNonSubInstInModal = 0;
            $scope.num_deleted = 0;
            $scope.num_edited = 0;
            $scope.searchLangData.profileUpdCount = 0;
            uuis = [];
            uuis_to_process = [];
            angular.forEach($scope.resultProfiles, function(value,index) {
                value.enable = $scope.allSelected;
            });
            as_upgrade(100);
        }

        $scope.toggleIndividualCheckbox = function(index) {
            if(angular.isDefined($scope.num_deleted))
                $scope.num_deleted = 0;
            if(angular.isDefined($scope.num_edited))
                $scope.num_edited = 0;
            if(angular.isDefined($scope.adminErrorMessage))
                $scope.adminErrorMessage = "";
            var val = $scope.allSelected;  
            if(angular.isUndefined($scope.num_selected))
                $scope.num_selected = 0;
            if(angular.isUndefined($scope.num_deleted))
                $scope.num_deleted = 0;
            if($scope.num_selected==0){
                $scope.resultCountForSubInstInModal = 0;
                $scope.resultCountForNonSubInstInModal = 0;
                uuis = [];
                uuis_to_process = [];
            }
            if(val){
                document.querySelector("#label_all").classList.remove("is-checked");
                document.querySelector("#all").checked=false;
                $scope.allSelected = false;
                uuis = $scope.resultProfiles.map(function(value,index) {                    
                        return value.uui;
                });
                $scope.num_selected = uuis.length;
                angular.forEach($scope.resultProfiles, function(v,k) {
                    v.enable = true;
                    if(v.basic_info.sub_cid && allowed_subinst.indexOf(v.basic_info.sub_cid)>=0){
                        if(angular.isUndefined($scope.resultCountForSubInstInModal))
                            $scope.resultCountForSubInstInModal = 0;
                        if($scope.resultCountForSubInstInModal<$scope.resultCountForSubInst){
                            $scope.resultCountForSubInstInModal +=1;
                            uuis_to_process.push(v.uui);
                        }
                    }
                    else if($rootScope.app_data.data.insti_type==3 && v.basic_info.sub_cid==null){
                        if(angular.isUndefined($scope.resultCountForNonSubInstInModal))
                            $scope.resultCountForNonSubInstInModal = 0;
                        if($scope.resultCountForNonSubInstInModal<$scope.resultCountForNonSubInst){
                            $scope.resultCountForNonSubInstInModal +=1;
                            uuis_to_process.push(v.uui);
                        }
                    }
                });
            }
            $scope.allSelected = false;
            if($scope.resultProfiles[index].enable){
                $scope.resultProfiles[index].enable = false;
                if($scope.resultProfiles[index].basic_info.sub_cid && allowed_subinst.indexOf($scope.resultProfiles[index].basic_info.sub_cid)>=0){
                        if(uuis_to_process.indexOf($scope.resultProfiles[index].uui) !== -1){
                            if(angular.isDefined($scope.resultCountForSubInstInModal))
                                $scope.resultCountForSubInstInModal -= 1;
                            uuis_to_process.splice(uuis_to_process.indexOf($scope.resultProfiles[index].uui),1);
                        }
                    }
                else if($rootScope.app_data.data.insti_type==3 && $scope.resultProfiles[index].basic_info.sub_cid==null){
                    if(uuis_to_process.indexOf($scope.resultProfiles[index].uui) !== -1){
                        if(angular.isDefined($scope.resultCountForNonSubInstInModal))
                            $scope.resultCountForNonSubInstInModal -= 1;
                        uuis_to_process.splice(uuis_to_process.indexOf($scope.resultProfiles[index].uui),1);
                    }
                } 
                if(uuis.indexOf($scope.resultProfiles[index].uui) !== -1){
                    uuis.splice(uuis.indexOf($scope.resultProfiles[index].uui),1);
                    $scope.num_selected -=1;
                }
                
                as_upgrade(10);
            }
            else{
                $scope.resultProfiles[index].enable = true;
                if($scope.resultProfiles[index].basic_info.sub_cid && allowed_subinst.indexOf($scope.resultProfiles[index].basic_info.sub_cid)>=0){
                        if(angular.isUndefined($scope.resultCountForSubInstInModal))
                            $scope.resultCountForSubInstInModal = 0;
                        $scope.resultCountForSubInstInModal +=1;
                        uuis_to_process.push($scope.resultProfiles[index].uui);
                    }
                else if($rootScope.app_data.data.insti_type==3 && $scope.resultProfiles[index].basic_info.sub_cid==null){
                    if(angular.isUndefined($scope.resultCountForNonSubInstInModal))
                        $scope.resultCountForNonSubInstInModal = 0;
                    $scope.resultCountForNonSubInstInModal +=1;
                    uuis_to_process.push($scope.resultProfiles[index].uui);
                }
                uuis.push($scope.resultProfiles[index].uui);
                $scope.num_selected +=1;
                
                as_upgrade(10);
            }
            if($scope.num_selected && angular.isDefined($scope.resultCount[0].count)){
                if($scope.num_selected==$scope.resultCount[0].count)
                    $scope.allSelected = true;
                as_upgrade(10);
            }
            $scope.searchLangData.profileSelCount = $scope.num_selected;
            $scope.searchLangData.profileUpdCount = $scope.num_edited;
        }

        $scope.editCallBack = function(num_edited,edited_field) {            
            if(((!$scope.allSelected && num_edited<$scope.num_selected) || ($scope.allSelected && num_edited<$scope.resultCount[0].count)) && edited_field=='role')
                $scope.adminErrorMessage = $filter("asPortalLang")("Admin_Edit_Err","Admin role cannot be changed.")
            if(((!$scope.allSelected && num_edited<$scope.num_selected) || ($scope.allSelected && num_edited<$scope.resultCount[0].count)) && edited_field=='auth_status')
                $scope.adminErrorMessage = $filter("asPortalLang")("Admin_Edit_Auth_Err","Admins authentication status cannot be changed.")
            $scope.num_edited = num_edited;
            $scope.searchLangData.profileUpdCount = $scope.num_edited;
            $scope.role_fields = ['degree','department','auth_status','specialization','institute','subinst','yoj','yop','role','identity_number'];
            if($rootScope.featureEnabled('multiple_role') && $scope.role_fields.indexOf(edited_field)>-1){
                $scope.edited_role_field=true;   
            }
            $scope.num_selected = 0;
            $scope.searchLangData.profileSelCount = 0;
            $scope.allSelected = false;
            if($scope.params_for_modal && $scope.params_for_modal[edited_field] && $scope.params_for_modal[edited_field]!=[] && $scope.params_for_modal[edited_field]!="" && !angular.equals({}, $scope.params_for_modal[edited_field])){
                if(uuis.length!=0){
                    var remaining_profiles = $scope.resultProfiles.filter(function(value,index) {
                        if(uuis.indexOf(value.uui)<0)
                            return value;
                    });
                    $scope.resultProfiles = remaining_profiles;
                    uuis = [];
                    uuis_to_process = [];
                }
                else{
                    $scope.resultProfiles = [];
                    as_upgrade(10);
                }
            }
            else{
                if(uuis.length!=0){
                    angular.forEach($scope.resultProfiles,function(value,index) {
                        value.enable = false;
                    });
                    uuis = [];
                    uuis_to_process = [];
                }
                else{
                    angular.forEach($scope.resultProfiles,function(value,index) {
                        value.enable = false;
                    });
                    as_upgrade(100);
                }
            }
            $scope.refreshProfiles();
        }

        $scope.editModal = function() {
            $scope.editable_fields['yoj']['show_edit_field'] = !$scope.isYojHide;
            $scope.editable_fields['yop']['show_edit_field'] = !$scope.isYopHide;
            $scope.editable_fields['institute']['show_edit_field'] = $scope.isInstitute;
            $scope.editable_fields['degree']['show_edit_field'] = !$scope.isDegreeHide;
            $scope.editable_fields['department']['show_edit_field'] = !$scope.isDepHide;
            $scope.editable_fields['specialization']['show_edit_field'] = $scope.isSpecialization;
            $scope.editable_fields['enrollment_number']['show_edit_field'] = $scope.isEnrollment;
            $scope.editable_fields['identity_number']['show_edit_field'] = $scope.isIdentity;
            $scope.editable_fields['dob']['show_edit_field'] = $scope.isDOB;
            $scope.editable_fields['gender']['show_edit_field'] = $scope.isGender;
            $scope.editable_fields['marital_status']['show_edit_field'] = $scope.isMaritalStatus;
                    
            // var params_for_modal = $scope.params_for_modal;

            var advanced_custom_field_type=['3'];
            angular.forEach($scope.search_data.fields,function(val,key) {
                if($scope.formFieldsConfig[key] && !$scope.search_data.fields[key].entity_info){
                    $scope.editable_fields[key] = {
                        name: $scope.search_data.fields[key]["displayName"],
                        edit:false,
                        clear:true,
                        show_edit_field:true
                    }
                    if($scope.search_data.fields[key].type && advanced_custom_field_type.indexOf($scope.search_data.fields[key].type)>-1){
                        $scope.editable_fields[key]['advanced_edit']=true;
                        $scope.editable_fields[key]['allowed_operations']={'add':true,'remove':true};
                        $scope.editable_fields[key]['responseType']='array';
                        $scope.editable_fields[key]['options']={
                            'add':angular.copy($scope.search_data.fields[key]['futherSearchParams']['dropdownList']),
                            'remove':angular.copy($scope.search_data.fields[key]['futherSearchParams']['dropdownList'])
                        }
                    }
                    if($scope.formFieldsConfig[key]){
                         $scope.editable_fields[key]["field_id"]=$scope.formFieldsConfig[key].match(/field_id_(\d+)/)[1];
                         $scope.editable_fields[key]['custom_field_type']=$scope.search_data.fields[key].custom_field_type;
                    }
                    if($scope.search_data.fields[key]["futherSearchType"] == "dropdown" || $scope.search_data.fields[key]["futherSearchType"] == "autocomplete"){
                        $scope.editable_fields[key]['edit']=true;
                    }
                }
            });
            var data = {fields: $scope.editable_fields,search_data:$scope.search_data, editable_fields: $scope.editable_fields};
            if(angular.isDefined($scope.num_selected) && $scope.num_selected!=0)
                data.total_profiles = $scope.num_selected;
            else
                data.total_profiles= $scope.resultCount[0].count;
            data.params_for_modal = $scope.params_for_modal;
            if(uuis_to_process.length!=0 || ($rootScope.app_data.admin_r_subinsti && uuis.length!=0))
                data.uuis = uuis_to_process;
            else
                data.uuis = uuis;
            data.editCallBack = $scope.editCallBack;
            data.cbInsti = $scope.filterDropdownOnChange;
            if($scope.resultCountForSubInstInModal || $scope.resultCountForNonSubInstInModal)
                data.num_profiles = angular.isDefined($scope.resultCountForSubInstInModal)?$scope.resultCountForSubInstInModal:0;
            else if($scope.resultCountForSubInst)
                data.num_profiles = $scope.resultCountForSubInst;
            if($scope.resultCountForNonSubInst)
                data.num_profiles_non_sub_insti = $scope.resultCountForNonSubInst;
            if(uuis_to_process.length!=0 || ($rootScope.app_data.admin_r_subinsti && uuis.length!=0)){
                // data.num_profiles = uuis_to_process.length;
                data.num_profiles_non_sub_insti = angular.isDefined($scope.resultCountForNonSubInstInModal)?$scope.resultCountForNonSubInstInModal:0;
            }
            if($scope.params_for_modal && $scope.params_for_modal["subinst"] && !isEmpty($scope.params_for_modal["subinst"]) && ($scope.params_for_modal["subinst"].isEmpty || $scope.params_for_modal["subinst"].isNotEmpty) && !(uuis_to_process.length!=0 || ($rootScope.app_data.admin_r_subinsti && uuis.length!=0))){
                if($scope.params_for_modal["subinst"]["isNotEmpty"]){
                    var subinst_params = allowed_subinst;
                    if(isEmpty(subinst_params))
                        data.num_profiles = 0;
                }
                if($scope.params_for_modal["subinst"]["isEmpty"]){
                    data.num_profiles = 0;
                }
            }
            else if($scope.params_for_modal && $scope.params_for_modal["subinst"] && !isEmpty($scope.params_for_modal["subinst"]) && !(uuis_to_process.length!=0 || ($rootScope.app_data.admin_r_subinsti && uuis.length!=0))){
                var subinst_params = [];
                angular.forEach(allowed_subinst,function(val,key) {
                    if($scope.params_for_modal["subinst"].indexOf(val)>=0)
                        subinst_params.push(val);
                });
                if(isEmpty(subinst_params))
                    data.num_profiles = 0;
            }
            data.displayName=$scope.displayName;
            analytics.event('search_edit_clicked,'+data.total_profiles+','+$scope.displayName+'');   
            ModalService.showModal({
                templateUrl : './templates/directives/search/searchEditModal.html',
                controller: 'searchEditModalCtrl',
                inputs: {
                    data: data,
                },
                target: document.body
            }).then(function(modal) {
                // modal.close.then(function() {
                //     console.log($scope);
                // });
            });
        }

        $scope.deleteCallBack = function(num_deleted,blocked,deleted) {
            if((!$scope.allSelected && num_deleted!=$scope.num_selected) || ($scope.allSelected && num_deleted!=$scope.resultCount[0].count))
                $scope.adminErrorMessage = $filter("asPortalLang")("Admin_Del_Err","Admins cannot be deleted or blocked.")
            $scope.blocked_users = parseInt(blocked);
            $scope.deleted_users = parseInt(deleted);
            $scope.searchLangData.profileDelCount = $scope.deleted_users;
            $scope.searchLangData.profileBlockCount = $scope.blocked_users;
            $scope.num_deleted = num_deleted;
            $scope.adminNotDeleted = true;
            $scope.allSelected = false;
            $scope.num_selected = 0;
            $scope.searchLangData.profileSelCount = 0;
            $scope.totalCount.count -= num_deleted;
            if(uuis.length!=0){
                var remaining_profiles = $scope.resultProfiles.filter(function(value,index) {
                    if(uuis.indexOf(value.uui)<0 || value.basic_info.role==4)
                        return value;
                    if(value.basic_info.role!=4)
                        value.enable = false;
                });
                $scope.resultProfiles = remaining_profiles;
                uuis = [];
                uuis_to_process = [];
            }
            else{
                $scope.resultProfiles = [];
                as_upgrade(10);
                $scope.vFetchProfiles();
            }
            $scope.refreshProfiles();
        }

        $scope.deleteModal = function() {
            var data = {fields: $scope.editable_fields, search_data:$scope.search_data};
            if(angular.isDefined($scope.num_selected) && $scope.num_selected!=0)
                data.total_profiles = $scope.num_selected;
            else
                data.total_profiles= $scope.resultCount[0].count;
            data.params_for_modal = $scope.params_for_modal;
            if($scope.resultCountForSubInstInModal || $scope.resultCountForNonSubInstInModal)
                data.num_profiles = angular.isDefined($scope.resultCountForSubInstInModal)?$scope.resultCountForSubInstInModal:0;
            else if($scope.resultCountForSubInst)
                data.num_profiles = $scope.resultCountForSubInst;
            if($scope.resultCountForNonSubInst)
                data.num_profiles_non_sub_insti = $scope.resultCountForNonSubInst;
            if(uuis_to_process.length!=0 || ($rootScope.app_data.admin_r_subinsti && uuis.length!=0)){
                // data.num_profiles = uuis_to_process.length;
                data.num_profiles_non_sub_insti = angular.isDefined($scope.resultCountForNonSubInstInModal)?$scope.resultCountForNonSubInstInModal:0;
            }
            data.deleteCallBack = $scope.deleteCallBack;
            if($scope.params_for_modal && $scope.params_for_modal["subinst"] && !isEmpty($scope.params_for_modal["subinst"]) && ($scope.params_for_modal["subinst"].isEmpty || $scope.params_for_modal["subinst"].isNotEmpty) && !(uuis_to_process.length!=0 || ($rootScope.app_data.admin_r_subinsti && uuis.length!=0))){
                if($scope.params_for_modal["subinst"]["isNotEmpty"]){
                    var subinst_params = allowed_subinst;
                    if(isEmpty(subinst_params))
                        data.num_profiles = 0;
                }
                if($scope.params_for_modal["subinst"]["isEmpty"]){
                    data.num_profiles = 0;
                }
            }
            else if($scope.params_for_modal && $scope.params_for_modal["subinst"] && !isEmpty($scope.params_for_modal["subinst"]) && !(uuis_to_process.length!=0 || ($rootScope.app_data.admin_r_subinsti && uuis.length!=0))){
                var subinst_params = [];
                angular.forEach(allowed_subinst,function(val,key) {
                    if($scope.params_for_modal["subinst"].indexOf(val)>=0)
                        subinst_params.push(val);
                });
                if(isEmpty(subinst_params))
                    data.num_profiles = 0;
            }
            if(uuis_to_process.length!=0 || ($rootScope.app_data.admin_r_subinsti && uuis.length!=0))
                data.uuis = uuis_to_process;
            else
                data.uuis = uuis;
            data.cbInsti = $scope.filterDropdownOnChange;
            data.displayName=$scope.displayName;
            analytics.event('search_delete_clicked,'+data.total_profiles+','+$scope.displayName+'');   
            ModalService.showModal({
                templateUrl : './templates/directives/search/searchDeleteModal.html',
                controller: 'searchDeleteModalCtrl',
                inputs: {
                    data: data,
                },
                target: document.body
            }).then(function(modal) {
                modal.close.then(function() {
                    // console.log(vSearchParams);
                    // console.log("sdfgh");
                    // if(!$rootScope.app_data.config.meta[67].canCloseModal) {
                    //     $state.go('inapp.admin',null,{reload:true});
                    // }
                });
            });
        }

    }

    searchEditModalCtrl.$inject = ['data','$scope', 'close','$http','$rootScope','$timeout','$state','analytics','userdata','$filter'];
    function searchEditModalCtrl(data,$scope, close, $http, $rootScope, $timeout, $state,analytics,userdata,$filter) {
                    as_upgrade(100);
                    $scope.role_fields = ['degree','department','auth_status','specialization','institute','subinst','yoj','yop','role','identity_number'];
                    $scope.data = data.fields;
                    $scope.displayName=data.displayName;
                    $scope.search_type='';
                    var cbInsti = data.cbInsti;
                    $scope.info = {};
                    $scope.showOptions = false;
                    var uuis = data.uuis;
                    if(angular.isDefined(data.num_profiles))
                        $scope.num_profiles = data.num_profiles;
                    else
                        $scope.num_profiles = data.total_profiles;
                    $scope.editModalLangData = {};
                    $scope.profileStatusTxt = $filter("asPortalLang")("Profile_Status","Profile Status");
                    $scope.total_profiles_to_process = angular.copy(parseInt($scope.num_profiles));
                    if(angular.isDefined(data.num_profiles_non_sub_insti)){
                        $scope.num_profiles_non_sub_insti = data.num_profiles_non_sub_insti;
                        $scope.total_profiles_to_process+= parseInt($scope.num_profiles_non_sub_insti);
                    }
                    $scope.editModalLangData.profEditCnt = $scope.total_profiles_to_process;
                    $scope.editting = false;
                    $scope.total_profiles = data.total_profiles;
                    $scope.callback = data.editCallBack;
                    var show_filtered_users = false;
                    var subinst_array = userdata.fetchAllowedSubinst();
                    $scope.isRoleField=function(){
                        if(angular.isDefined($scope.edit_property_key) && ($scope.role_fields.indexOf($scope.edit_property_key)>-1 || ($scope.data[$scope.edit_property_key].custom_field_type && $scope.data[$scope.edit_property_key].custom_field_type=='role_info')) ){
                            return true;
                        }
                        else
                            return false;
                    }
                    $scope.close = function($event) {
                        if($scope.editting) return;
                        close($event);
                        if((angular.isDefined(document.querySelector("#show_mem")) && document.querySelector("#show_mem").checked) || show_filtered_users){
                            if($rootScope.app_data.admin_r_subinsti){
                                var subinst_array = userdata.fetchAllowedSubinst();
                            }
                            if($rootScope.app_data.admin_r_subinsti.length!=subinst_array)
                                cbInsti(subinst_array,'subinst');
                        }
                    };
                    $scope.params_for_modal = data.params_for_modal;
                    
                    // show warning that multiple roles will be edited (if applicable)
                    $scope.show_multi_role_warn = ($rootScope.featureEnabled('multiple_role'))?true:false;
                    for (var i = 0; i < $scope.role_fields.length; i++) {
                        if($scope.params_for_modal[$scope.role_fields[i]] && ($scope.params_for_modal[$scope.role_fields[i]].length || (angular.isUndefined($scope.params_for_modal[$scope.role_fields[i]].length) && !angular.equals({},$scope.params_for_modal[$scope.role_fields[i]])))){
                            $scope.show_multi_role_warn = false;
                            break;
                        }
                    }
                    
                    // enable show_multi_role_warn if profiles are being edited based on uui rather then the actual filters
                    var elem_tmp = document.querySelectorAll('input[name="profiles"]:checked');
                    var total_elem_tmp = document.querySelectorAll('.cb');
                    if(!(elem_tmp.length == total_elem_tmp.length || elem_tmp.length==0) && $rootScope.featureEnabled('multiple_role'))
                        $scope.show_multi_role_warn = true;
                    
                    $scope.search_data = data.search_data;
                    if($rootScope.app_data.admin_r_subinsti)
                        $scope.step1 = true;
                    else
                        $scope.step1 = false;
                    
                    $scope.buttonDisabled = true;
                    $scope.selectDisabled = true;
                    
                    $scope.toggleOptions = function(val) {
                        if(angular.isDefined(val))
                            $scope.showOptions = val;
                        else
                            $scope.showOptions = !$scope.showOptions;
                    }
                    $scope.changeStep = function() {
                        if(angular.isDefined(document.querySelector("#show_mem")) && document.querySelector("#show_mem").checked){
                            show_filtered_users = true;
                            $scope.step1 = false;
                        }
                        else
                            $scope.step1 = false;
                    }
                    $scope.onchange = function(val) {
                        $scope.buttonDisabled=false;
                        if(angular.isDefined(val) && val==false){
                            $scope.selectDisabled = true;
                        }
                        as_upgrade(100);
                    }
                    $scope.selectChange = function(val,check) {
                        $scope.selectDisabled = val;
                        if(angular.isDefined(check) && check){
                            if(!$scope.field.finalval)
                                $scope.buttonDisabled = true;
                        }
                        as_upgrade(100);
                    }
                    $scope.change_search_type=function(type){
                        if($scope.search_type!=''){
                            change_checked_state(false,true);
                            if(type!='removeAll')
                                $scope.search_type=type;
                            else{
                                $scope.search_type='';
                                $scope.buttonDisabled = false;
                            }
                            if($scope.field.finalval && $scope.data[$scope.edit_property_key].responseType=='array' && $scope.field.finalval[$scope.field.futherSearchParams.serviceNameField]) 
                               $scope.field.finalval[$scope.field.futherSearchParams.serviceNameField]=[];
                           else
                                $scope.field.finalval='';
                        }
                        else{
                            if(type == 'removeAll'){
                                $scope.search_type = '';
                                $scope.field.finalval = '';
                            }
                            else{
                                $scope.search_type=type;
                                $scope.buttonDisabled = true;
                            }
                        }
                    }
                    function change_checked_state(id,All){
                        if($scope.data[$scope.edit_property_key].options && $scope.data[$scope.edit_property_key].options[$scope.search_type]){
                            angular.forEach($scope.data[$scope.edit_property_key].options[$scope.search_type],function(checkbox){
                                if(!All){
                                    if(checkbox.id==id){
                                        checkbox.checked=!checkbox.checked;
                                    }
                                }
                                else{
                                    checkbox.checked=false;
                                    $scope.buttonDisabled=true;
                                }
                               
                            });
                        }
                    }
                    $scope.trig_func=function (data,isArray) {
                        if(!isArray){
                            $scope.field.finalval = data;
                            $scope.buttonDisabled=false;
                        }
                        else{
                            if($scope.field.finalval) {
                                if($scope.field.finalval[$scope.field.futherSearchParams.serviceNameField].indexOf(data)>-1){
                                    change_checked_state(data);
                                    $scope.field.finalval[$scope.field.futherSearchParams.serviceNameField].splice($scope.field.finalval[$scope.field.futherSearchParams.serviceNameField].indexOf(data),1);   
                                }
                                else {
                                    console.log($scope.field.vCheckboxes);
                                    change_checked_state(data);
                                    $scope.field.finalval[$scope.field.futherSearchParams.serviceNameField].push(data);
                                }
                            }
                            else {
                                $scope.field.finalval={};
                                $scope.field.finalval[$scope.field.futherSearchParams.serviceNameField]=[];
                                change_checked_state(data);
                                $scope.field.finalval[$scope.field.futherSearchParams.serviceNameField].push(data);
                            }
                            if($scope.field.finalval[$scope.field.futherSearchParams.serviceNameField].length==0){
                                $scope.buttonDisabled=true;
                            }
                            else{
                                $scope.buttonDisabled=false;
                            }
                        }
                        console.log($scope.field.finalval);
                        as_upgrade(100);
                    }
                    $scope.selectProperty = function(dt,key) {
                        $scope.search_type='';
                        $scope.customfield_id='';
                        $scope.custom_field_type='';
                        $scope.selectDisabled = true;
                        if(document.querySelector("#edit")){
                            document.querySelector("#edit").checked = false;
                            document.querySelector("#edit_label").classList.remove('is-checked');
                            as_upgrade(10);
                        }
                        $scope.edit_property = dt.name;
                        $scope.edit_property_key = key;
                        if(dt.field_id){
                            $scope.customfield_id=dt.field_id;
                        }
                        if(dt.custom_field_type){
                            $scope.custom_field_type=dt.custom_field_type;
                        }
                        $scope.editModalLangData.editProp = $scope.edit_property;

                        console.log("bbbbbbbbbbbb",dt,key,data.search_data);

                        angular.forEach(data.search_data.categories,function(v,k) {
                            if(v.fields.indexOf(key) !== -1){
                                var field = angular.copy(data.search_data.fields[key]);
                                if(key=='role')
                                    field.futherSearchParams.dropdownList.splice(-1,1);
                                $scope.field = field;
                                if($scope.field.futherSearchType=='customfield'){
                                    $scope.field.localautocomplete.data.triggerFunction = $scope.trig_func;
                                    
                                }
                                as_upgrade(100);
                            }
                        });
                        if($scope.data && $scope.data[key] && !$scope.data[key].clear && $scope.data[key].edit){
                            $scope.info.checkEditField = true;
                            $scope.selectDisabled = false;
                            if(!$scope.field.finalval)
                                $scope.buttonDisabled = true;
                            else
                                $scope.buttonDisabled=false;
                        }
                        else
                            $scope.info.checkEditField = false;

                        if($scope.data && $scope.data[key] && !$scope.data[key].edit && $scope.data[key].clear){
                            $scope.info.checkClearField = true;
                            $scope.selectDisabled = true;
                            $scope.buttonDisabled=false;
                        }
                        else
                            $scope.info.checkClearField = false;
                        as_upgrade(100);
                    }
                    // $scope.preEditField = function() {
                    //     var val = document.querySelector('input[id="delete"]:checked');                        
                    //     if(angular.isUndefined($scope.edit_property_key) || $scope.edit_property_key==-1){
                    //         snackbar_general("Please choose a property to edit", 3000);
                    //         return;
                    //     }
                    //     if($scope.edit_property_key=='city' && $rootScope.featureEnabled('chapters')){
                    //         swal({
                    //                 type: "warning",
                    //                 text: "On updating current location of users, all chapters in your communities will be updated and manually added users might be removed. Would you like to continue?",
                    //                 buttons: ["Cancel", "Yes, Continue"]
                    //             }).then(function(res) { 
                    //             if(res==true){
                    //                 $scope.editField();
                    //             }
                    //         });
                    //     }
                    //     else
                    //         $scope.editField();
                    // }
                    $scope.editField = function() {
                        var val = document.querySelector('input[id="delete"]:checked');                        
                        if(angular.isUndefined($scope.edit_property_key) || $scope.edit_property_key==-1){
                            snackbar_general($filter("asPortalLang")("Empty_Prop_Err","Please choose a property to edit"), 3000);
                            return;
                        }
                        if($scope.field.finalval && $scope.field.finalval.id && ($scope.field.finalval.id=="blocked" || $scope.field.finalval.id=="rejected") && (!$scope.field.futherSearchParams || !$scope.field.futherSearchParams.auth_message || $scope.field.futherSearchParams.auth_message=='')){
                            snackbar_general($filter("asPortalLang")("Share_Reason_Err","Please share your reason with them"), 3000);
                            return;
                        }
                        var subInstFilterApplied = false;
                        if(angular.isDefined(subinst_array) && subinst_array.length>0){
                            if($scope.params_for_modal && $scope.params_for_modal["subinst"] && !isEmpty($scope.params_for_modal["subinst"]) && ($scope.params_for_modal["subinst"].isEmpty || $scope.params_for_modal["subinst"].isNotEmpty)){
                                if($scope.params_for_modal["subinst"]["isNotEmpty"]){
                                    var subinst_params = subinst_array;
                                    $scope.params_for_modal["subinst"] = angular.copy(subinst_params);
                                    subInstFilterApplied = true;
                                }
                            }
                            else if($scope.params_for_modal && $scope.params_for_modal["subinst"] && !isEmpty($scope.params_for_modal["subinst"])){
                                var subinst_params = [];
                                angular.forEach(subinst_array,function(val,key) {
                                    if($scope.params_for_modal["subinst"].indexOf(val)>=0)
                                        subinst_params.push(val);
                                });
                                $scope.params_for_modal["subinst"] = angular.copy(subinst_params);
                                subInstFilterApplied = true;
                            }
                            else
                                $scope.params_for_modal["subinst"] = subinst_array;
                            if(isEmpty($scope.params_for_modal["subinst"])){
                                snackbar_general($filter("asPortalLang")("Edit_Users_Rights_Err","You don't have rights to edit these users."), 3000);
                                return;
                            }
                        }
                        var _vSearchParams = Object.keys($scope.params_for_modal).reduce(function(p,k) {
                            if(['stream','other_params','rnd'].indexOf(k)!==-1)
                                return p;
                            if($scope.search_data.fields[k]) {
                                var v = $scope.search_data.fields[k];
                                if(v.dataPreProcessors && v.dataPreProcessors.constructor==Array && v.dataPreProcessors.length>0) {
                                    for (var i = 0; i < v.dataPreProcessors.length; i++) {
                                        $scope.params_for_modal = v.dataPreProcessors[i]($scope.params_for_modal,$scope.params_for_modal[k],k,v);
                                    }
                                }
                            }
                            return p;
                        },$scope.params_for_modal);
                        if(angular.isDefined(subinst_array) && subinst_array.length>0 && !subInstFilterApplied) {
                            if(!_vSearchParams.other_params) _vSearchParams.other_params = {};
                            _vSearchParams.other_params['includeNonSubInstiUsers'] = true;
                        }
                        var data = {};
                        var elem = document.querySelectorAll('input[name="profiles"]:checked');
                        var total_elem = document.querySelectorAll('.cb');
                        if(elem.length == total_elem.length || elem.length==0)
                            data.target_user_method = 'search_target';
                        else
                            data.target_user_method = 'uuis_target';
                        if(elem.length == total_elem.length || elem.length==0){
                            data.target_user_data = _vSearchParams;
                        }
                        else{
                            data.target_user_data = uuis;                        
                        }
                        if(!data.extra_operation_data)
                            data.extra_operation_data={};
                        if($scope.search_type!='')
                            data.extra_operation_data['sub_operation']=$scope.search_type;
                        if($scope.custom_field_type!='')
                        {
                            data.extra_operation_data['field_type']=$scope.custom_field_type;
                        }
                        if($scope.customfield_id!=''){
                            data.extra_operation_data['field_id']=$scope.customfield_id;
                            data.operation='custom_field';
                        }
                        else{
                            data.operation = $scope.edit_property_key;
                        }
                        if(val){
                            data.operation_data = '';
                        }
                        else{
                            if($scope.customfield_id!=''){
                                //hardcoded for dropdown types
                                if(!data.extra_operation_data.sub_operation)
                                    data.extra_operation_data['sub_operation']='add';
                            }
                            // angular.forEach($scope.field.finalval,function(val,key) {
                            //     if(key!='id')
                            //         data.operation_data = val;
                            //     if($scope.field=='role' && key==id)
                            //         data.operation_data = val;
                            // });
                            if(angular.isDefined($scope.field.finalval)){
                                if(isScalar($scope.field.finalval))
                                    data.operation_data = $scope.field.finalval;
                                else if(data.operation=='role' || data.operation=='subinst' || data.operation=='institute' || data.operation=='professional_networks' || data.operation=='degree' || data.operation=='department' || data.operation=='specialization' || data.operation=='auth_status' || data.operation=='gender'){
                                    data.operation_data = $scope.field.finalval.id;
                                }
                                else{
                                    data.operation_data = $scope.field.finalval[$scope.field.futherSearchParams.serviceNameField];
                                }
                                if($scope.field.futherSearchType=='autocomplete'){
                                    if(data.operation_data==-1){
                                        data.operation_data = $scope.field.futherSearchParams.textSelected;
                                    }
                                }
                            }
                        }

                        // id: isScalar(selectedData)?selectedData:selectedData[$scope.search_data.fields[field].futherSearchParams.serviceIdField],
                        // name: isScalar(selectedData)?selectedData:selectedData[$scope.search_data.fields[field].futherSearchParams.serviceNameField],

                        if((angular.isUndefined(data.operation_data) || !data.operation_data) && !val){
                            snackbar_general($filter("asPortalLang")("Edit_Users_Empty_Err","Please give a value for editing"), 3000);
                            return;
                        }
                        if(!data.extra_operation_data)
                           data.extra_operation_data = {};
                        if($scope.field.finalval && $scope.field.finalval.id && ($scope.field.finalval.id=="blocked" || $scope.field.finalval.id=="rejected")){
                            if($scope.field.futherSearchParams.auth_message)
                                data.extra_operation_data.auth_message = $scope.field.futherSearchParams.auth_message;
                        }
                        $scope.editting = true;
                        console.log("------------",data);
                        $http({
                            url: './communities/admin/bulk_operations_ctrl/execute',
                            method: 'POST',
                            data: data,
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            }
                        }).success(function(response) {
                            $scope.editting = false;
                            $scope.close();
                            if(response.success==1){
                                $scope.callback(response.data,$scope.edit_property_key);
                                if(response.data){
                                    snackbar_general($filter("asPortalLang")("Data_Updated_Success","Data updated successfully!!"), 3000);
                                    analytics.event('search_edit_completed,'+$scope.edit_property_key+':'+data.operation_data+','+$scope.displayName+'count:'+response.data+'');   
                                }
                            }
                            else{
                                snackbar_general($filter("asPortalLang")("Err_Something_Wrong","Something went wrong. Please try again..!!"), 3000);
                            }

                        });
                    }
                }

    searchDeleteModalCtrl.$inject = ['data','$scope', 'close','$http', '$rootScope','analytics','userdata','$filter'];      
    function searchDeleteModalCtrl(data,$scope, close, $http, $rootScope,analytics,userdata,$filter) {
                    as_upgrade(100);
                    var show_filtered_users = false;
                    $scope.buttonDisabled = true;
                    $scope.deleting = false;
                    $scope.data = data.fields;
                    $scope.displayName=data.displayName;
                    $scope.info = {};
                    var uuis_to_delete = data.uuis;
                    var cbInsti = data.cbInsti;
                    if(angular.isDefined(data.num_profiles))
                        $scope.num_profiles = data.num_profiles;
                    else
                        $scope.num_profiles = data.total_profiles;
                    $scope.delModalLangData = {};
                    $scope.total_profiles_to_process = angular.copy(parseInt($scope.num_profiles));
                    if(angular.isDefined(data.num_profiles_non_sub_insti)){
                        $scope.num_profiles_non_sub_insti = data.num_profiles_non_sub_insti;
                        $scope.total_profiles_to_process+= parseInt($scope.num_profiles_non_sub_insti);
                    }
                    $scope.delModalLangData.profDelCnt = $scope.total_profiles_to_process;
                    $scope.total_profiles = data.total_profiles;
                    var subinst_array = userdata.fetchAllowedSubinst();
                    $scope.enableButton = function() {
                        if($scope.info.pwd)
                            $scope.buttonDisabled = false;
                        else
                            $scope.buttonDisabled = true;
                    }
                    $scope.close = function($event) {
                        if($scope.deleting) return;
                        close($event);
                        if((angular.isDefined(document.querySelector("#show_mem")) && document.querySelector("#show_mem").checked) || show_filtered_users){
                            if($rootScope.app_data.admin_r_subinsti){
                                subinst_array = userdata.fetchAllowedSubinst();
                            }
                            if($rootScope.app_data.admin_r_subinsti.length!=subinst_array)
                                cbInsti(subinst_array,'subinst');
                        }
                    };
                    $scope.params_for_modal = data.params_for_modal;
                    $scope.search_data = data.search_data;
                    $scope.callback = data.deleteCallBack;
                    if($rootScope.app_data.admin_r_subinsti)
                        $scope.step1 = true;
                    else
                        $scope.step1 = false;
                    $scope.changeStep = function() {
                        if(angular.isDefined(document.querySelector("#show_mem")) && document.querySelector("#show_mem").checked){
                            show_filtered_users = true;
                            $scope.step1 = false;
                        }
                        else
                            $scope.step1 = false;
                    }
                    $scope.deleteUsersCheck = function() {
                        $scope.deleting = true;
                        var pwdCheckData = {
                            enteredPass: $scope.info.pwd
                        };
                        $http.post('./search/checkPasswordOnDownload', pwdCheckData).then(function(res) {
                            if (res.data.success == 1 && res.data.token){
                                $scope.deleteUsers();
                            }
                            else{
                                $scope.deleting = false;
                                swal({
                                    title: $filter("asPortalLang")("Incorrect_Password","Incorrect Password"),
                                    text: $filter("asPortalLang")("Empty_Pass_Err","If you don't have password, click Set Now"),
                                    icon: "warning",
                                    buttons: {
                                    cancel:$filter("asPortalLang")("Close","Close"),
                                    catch: {
                                        text: $filter("asPortalLang")("Set_Now","Set Now"),
                                        value: true,
                                        },
                                    },
                                    dangerMode: true,
                                })
                                .then( function (willDelete) {
                                  if (willDelete) {
                                    try{
                                      showSpinner();
                                      $http.post('./changepassword/logged_in_api?redirect=search').then(function(res) {
                                          hideSpinner();
                                          if (res.data && res.data.success==1) {
                                            swal($filter('asPortalLang')('Change_Password_Swal',"A mail has been sent to your registered email id with instructions to set password."));
                                          }
                                          else if(res.data && res.data.success == 0 && res.data.errorcode == "LIMIT_EXCEEDED"){
                                            swal({text: res.data.error, "title":$filter('asPortalLang')('Action_Limit_Restriction',"Access Temporary Restricted")});
                                          }
                                        });
                                      $scope.close();
                                    }
                                    catch(e){};
                                  } else {
                                    
                                  }
                                })
                              }
                        });
                    }
                    $scope.deleteUsers = function() {
                        $scope.deleting = true;
                        var subInstFilterApplied = false;
                        if(angular.isDefined(subinst_array) && subinst_array.length>0){
                            if($scope.params_for_modal && $scope.params_for_modal["subinst"] && !isEmpty($scope.params_for_modal["subinst"]) && ($scope.params_for_modal["subinst"].isEmpty || $scope.params_for_modal["subinst"].isNotEmpty)){
                                if($scope.params_for_modal["subinst"]["isNotEmpty"]){
                                    var subinst_params = subinst_array;
                                    $scope.params_for_modal["subinst"] = angular.copy(subinst_params);
                                    subInstFilterApplied = true;
                                }
                            }
                            else if($scope.params_for_modal && $scope.params_for_modal["subinst"] && !isEmpty($scope.params_for_modal["subinst"])){
                                var subinst_params = [];
                                angular.forEach(subinst_array,function(val,key) {
                                    if($scope.params_for_modal["subinst"].indexOf(val)>=0)
                                        subinst_params.push(val);
                                });
                                $scope.params_for_modal["subinst"] = angular.copy(subinst_params);
                                subInstFilterApplied = true;
                            }
                            else
                                $scope.params_for_modal["subinst"] = subinst_array;
                            if(isEmpty($scope.params_for_modal["subinst"])){
                                snackbar_general($filter("asPortalLang")("Edit_Users_Rights_Err","You don't have rights to edit these users."), 3000);
                                return;
                            }
                        }
                        var _vSearchParams = Object.keys($scope.params_for_modal).reduce(function(p,k) {
                            if(['stream','other_params','rnd'].indexOf(k)!==-1)
                                return p;
                            if($scope.search_data.fields[k]) {
                                var v = $scope.search_data.fields[k];
                                if(v.dataPreProcessors && v.dataPreProcessors.constructor==Array && v.dataPreProcessors.length>0) {
                                    for (var i = 0; i < v.dataPreProcessors.length; i++) {
                                        $scope.params_for_modal = v.dataPreProcessors[i]($scope.params_for_modal,$scope.params_for_modal[k],k,v);
                                    }
                                }
                            }
                            return p;
                        },$scope.params_for_modal);
                        if(angular.isDefined(subinst_array) && subinst_array.length>0 && !subInstFilterApplied) {
                            if(!_vSearchParams.other_params) _vSearchParams.other_params = {};
                            _vSearchParams.other_params['includeNonSubInstiUsers'] = true;
                        }
                        var data = {};
                        var elem = document.querySelectorAll('input[name="profiles"]:checked');
                        var total_elem = document.querySelectorAll('.cb');
                        if(elem.length == total_elem.length || elem.length==0)
                            data.target_user_method = 'search_target';
                        else
                            data.target_user_method = 'uuis_target';
                        if(elem.length == total_elem.length || elem.length==0){
                            data.target_user_data = _vSearchParams;
                        }
                        else{
                            data.target_user_data = uuis_to_delete;                        
                        }
                        data.operation = 'delete_user';

                        // console.log(data);

                        // return;


                        $http({
                            url: './communities/admin/bulk_operations_ctrl/execute',
                            method: 'POST',
                            data: data,
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            }
                        }).success(function(response) {
                            $scope.deleting = false;
                            $scope.close();
                            if(response.success==1){
                                var deleted_cnt = 0;
                                if(response.data){
                                    if(angular.isDefined(response.data['blocked'])){
                                        deleted_cnt += parseInt(response.data['blocked']);
                                    }
                                    if(angular.isDefined(response.data['deleted'])){
                                        deleted_cnt += parseInt(response.data['deleted']);
                                    }
                                }
                                $scope.callback(deleted_cnt,response.data['blocked'],response.data['deleted']);
                                if(response.data){
                                    snackbar_general($filter("asPortalLang")("Data_Del_Success","Data deleted successfully!!"), 3000);
                                    analytics.event('search_delete_completed,'+deleted_cnt+','+$scope.displayName+'');   
                                }

                            }
                            else{
                                snackbar_general($filter("asPortalLang")("Err_Something_Wrong","Something went wrong. Please try again..!!"), 3000);
                            }
                        });
                        // body...
                    }
                }              

})();